import type { CurrentUserDto } from '@lagerfeuer/shared';
import { create } from 'zustand';

interface AuthState {
  accessToken: string | null;
  user: CurrentUserDto | null;
  setSession(token: string, user: CurrentUserDto): void;
  clear(): void;
}

/** Access-Token nur im Speicher (nie localStorage); Refresh läuft über das httpOnly-Cookie. */
export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  setSession: (accessToken, user) => set({ accessToken, user }),
  clear: () => set({ accessToken: null, user: null }),
}));
